export const SuspendedContactIcon = () => {
  return (
    <svg
      data-name="Grupo 7101"
      height="30.801"
      id="Grupo_7101"
      viewBox="0 0 38.156 35.801"
      width="32.156"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="9.648"
        cy="9.648"
        data-name="Elipse 1842"
        fill="#ff715b"
        id="Elipse_1842"
        rx="9.648"
        ry="9.648"
        transform="translate(5.644 0)"
      />
      <path
        d="M1115.035,719.539a7.563,7.563,0,1,0,0,10.7h0a7.519,7.519,0,0,0,.063-10.632C1115.066,719.57,1115.066,719.539,1115.035,719.539Zm-4.348,8.347-1.016-1.016-1.016,1.016a1.5,1.5,0,0,1-2.126-2.126l1.016-1.016-1.016-1.016a1.5,1.5,0,0,1,2.126-2.126l1.016,1.016,1.016-1.016a1.5,1.5,0,0,1,2.126,2.126l-1.016,1.016,1.016,1.016a1.5,1.5,0,1,1-2.126,2.126Z"
        fill="#ff715b"
        id="Trazado_3239_00000163067092498572406450000009396373457746243464_"
        transform="translate(-1079.113 -697.131)"
      />
      <path
        d="M1049.544,723.192a10.888,10.888,0,0,1,3.808-8.252c-.063-.032-.127-.1-.19-.127a1.3,1.3,0,0,0-1.428,0,11.833,11.833,0,0,1-13.616,0,1.241,1.241,0,0,0-1.428,0c-5.4,3.586-6.919,10.537-6.919,10.537s-1.4,5.713,4.253,5.713h18.884A10.956,10.956,0,0,1,1049.544,723.192Z"
        data-name="Trazado 4392"
        fill="#ff715b"
        id="Trazado_4392"
        transform="translate(-1029.618 -695.262)"
      />
    </svg>
  );
};
